import { ProjectStatus } from 'generated/graphql';
import { Tooltip } from '@spotted-zebra-uk/ui-components';
import styles from './PolicyDependentButton.module.scss';

type TPolicyDependentButtonProps = {
  projectStatus?: ProjectStatus;
  customTooltipContent?: string;
  id: string;
  renderItem: (disabled: boolean) => JSX.Element;
  disabled?: boolean;
};

const closedStatusTooltipContent =
  'This action is disabled because this role is closed.';

const PolicyDependentButton = ({
  customTooltipContent,
  id,
  renderItem,
  projectStatus = ProjectStatus.Draft,
  disabled = false,
}: TPolicyDependentButtonProps) => {
  const tooltipContent =
    projectStatus === ProjectStatus.Closed
      ? closedStatusTooltipContent
      : customTooltipContent || 'This action is currently disabled.';

  if (disabled) {
    return (
      <Tooltip
        content={tooltipContent}
        id={`${id}-policy-dependent-button-tooltip`}
        className={styles.tooltip}
      >
        <div
          id={`${id}-policy-dependent-button-tooltip-trigger`}
          className={styles.disabledButtonContainer}
        >
          {renderItem(true)}
        </div>
      </Tooltip>
    );
  }
  return renderItem(false);
};

export default PolicyDependentButton;
